import React from 'react';
import { useLocation } from 'react-router-dom';

// Util for parsing query strings from the url.
export default function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}